import { render, staticRenderFns } from "./CreateNewResponse.vue?vue&type=template&id=49805900&scoped=true"
import script from "./CreateNewResponse.vue?vue&type=script&lang=ts"
export * from "./CreateNewResponse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49805900",
  null
  
)

export default component.exports